<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  data() {
    return {
      isPasswordVisible: false,
      startdate: currentDate,
      startdateOne: currentDateOne,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      OfferFixSel: ["Select", "Fixed"],
      EditOfferFixSel: ["Select", "Fixed"],
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    submitForm() {
      this.$router.push("/provider/provider-offers");
    },
  },
};
</script>
<template>
  <!-- Add Offers -->
  <div
    class="modal fade wallet-modal"
    id="add-offer"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Add Offer</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Offer Type</label>
                  <vue-select
                    :options="OfferFixSel"
                    id="offerfixsel"
                    plaecholder="Select"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Offer Price</label>
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">Start Date</label>
                <div class="input-icon position-relative">
                  <span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">End Date</label>
                <div class="input-icon position-relative">
                  <span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
                  <date-picker
                    v-model="startdateOne"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="submit" class="btn btn-dark">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Offers -->

  <!-- Edit Offers -->
  <div
    class="modal fade wallet-modal"
    id="edit-offer"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Edit Offer</h5>
          <a href="#" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Offer Type</label>
                  <vue-select
                    :options="EditOfferFixSel"
                    id="editofferfixsel"
                    plaecholder="Fixed"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Offer Price</label>
                  <input type="text" class="form-control" value="$20" />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">Start Date</label>
                <div class="input-icon position-relative">
                  <span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <label class="form-label">End Date</label>
                <div class="input-icon position-relative">
                  <span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
                  <date-picker
                    v-model="startdate"
                    placeholder=""
                    class="datetimepicker form-control"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="submit" class="btn btn-dark">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Offers -->

  <!-- Delete offer -->
  <div class="modal fade custom-modal" id="del-offer">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Offer</h5>
          <a href="#" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body">
          <div class="write-review">
            <form @submit.prevent="submitForm">
              <p>Are you sure want to delete this offer?</p>
              <div class="modal-submit text-end">
                <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</a>
                <button type="submit" class="btn btn-dark">Yes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete offer -->

  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
